import { render, staticRenderFns } from "./TeamRequestsManagerPage.vue?vue&type=template&id=b9d3ed06"
import script from "./TeamRequestsManagerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamRequestsManagerPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports